import React from "react";
import _PhoneInput from "react-phone-input-2";
import { allCountriesMasks } from "../constants";

export default function PhoneInput(props) {
  return (
    <>
      <_PhoneInput masks={allCountriesMasks} {...props} />
    </>
  );
}
